import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ behavior = "auto" }) {
  const { pathname, search } = useLocation();

  // Disable browser's saved scroll position on back/forward
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = "manual";
      return () => { window.history.scrollRestoration = prev; };
    }
  }, []);

  // Scroll to top on every route (path or query) change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, search, behavior]);

  return null;
}
